import moment from "moment"
import { CiSearch } from "react-icons/ci"
import { useSelector } from "react-redux"

export const locations = [
  { _id: 1, title: "Kokand-Fergana" },
  { _id: 2, title: "Kokand-Rishtan" },
  { _id: 3, title: "Rishtan-Oltiariq" },
  { _id: 4, title: "Rishatn-Margilan" },
  { _id: 5, title: "Kokand-Margilan" },
  { _id: 6, title: "Margilan-Fergana" },
]

export const filterElement = () => {
  const { categories, regions } = useSelector((state) => state.appReducer)

  const filtersSelect = [
    // {
    //   name: "year",
    //   option: years,
    //   label: "filter-year",
    //   placeholder: "",
    //   // icon: CalendarIcon,
    // },
    {
      name: "region",
      option: regions,
      label: "filter-region",
      placeholder: "filter-region",
      icon: CiSearch,
      language: false,
    },
    // {
    //   name: "group",
    //   option: groups,
    //   label: "Соҳалар",
    //   placeholder: "Соҳалар",
    //   icon: CiSearch,
    // },
    {
      name: "category",
      option: categories,
      label: "filter-objects",
      placeholder: "filter-objects",
      icon: CiSearch,
      language: true,
    },
  ]

  return filtersSelect
}

export const data = [
  {
    _id: "6328136f903ad2417e446ef8",
    lat: 40.3721116,
    lng: 71.2657047,
  },
  {
    _id: "63281289e3650a8a42e95252",
    lat: 40.3729108,
    lng: 71.2649623,
  },
  {
    _id: "63281219e3650a8a42e95245",
    lat: 40.3739981,
    lng: 71.2652347,
  },
  {
    _id: "63280c98e3650a8a42e95217",
    lat: 40.3740013,
    lng: 71.2652399,
  },
  {
    _id: "63280be8096dcf2f916bd96c",
    lat: 40.3740004,
    lng: 71.2652406,
  },
  {
    _id: "63280b3e966c5ba3ade1b2d2",
    lat: 40.3740007,
    lng: 71.2652406,
  },
  {
    _id: "63280a559c5badbb7b75b406",
    lat: 40.3739989,
    lng: 71.2652412,
  },
  {
    _id: "63280a10276a8ee311895aee",
    lat: 40.3739996,
    lng: 71.2652408,
  },
  {
    _id: "632809bbf92eb97fadf310ac",
    lat: 40.3740009,
    lng: 71.26524,
  },
  {
    _id: "632808ee301f4523cbb0c188",
    lat: 40.3740003,
    lng: 71.2652404,
  },
  {
    _id: "6328083a5b3409d545e76365",
    lat: 40.3740011,
    lng: 71.2652399,
  },
  {
    _id: "632807735b3409d545e76339",
    lat: 40.3729108,
    lng: 71.2649623,
  },
  {
    _id: "6328075484a6dc03691eafe8",
    lat: 40.374,
    lng: 71.2652413,
  },
  {
    _id: "6327ff39632c0b9c8ece0572",
    lat: 40.3739975,
    lng: 71.2652367,
  },
  {
    _id: "632801fe5b3409d545e76318",
    lat: 40.4262369,
    lng: 71.5191654,
  },
  {
    _id: "6328029c632c0b9c8ece05ab",
    lat: 40.4262369,
    lng: 71.5191654,
  },
  {
    _id: "63270a64cc94598184898b7f",
    lat: 40.373999,
    lng: 71.2652316,
  },
  {
    _id: "632580cc3a1c40b2bbb01d96",
    lat: 40.36521,
    lng: 71.5233967,
  },
  {
    _id: "632580c97fa5f0616ce68850",
    lat: 40.3632033,
    lng: 71.5183167,
  },

  {
    _id: "632580c23a1c40b2bbb01d8e",
    lat: 40.3594233,
    lng: 71.5090283,
  },

  {
    _id: "632580b82451215603b31f68",
    lat: 40.3560367,
    lng: 71.5005833,
  },
  {
    _id: "632580a83a1c40b2bbb01d86",
    lat: 40.3548017,
    lng: 71.49755,
  },
  {
    _id: "632580a07fa5f0616ce68840",
    lat: 40.351465,
    lng: 71.488505,
  },
  {
    _id: "6321a99ba9c6e5e1c3013a13",
    lat: 40.3740548,
    lng: 71.2652457,
  },
  {
    _id: "62fde26143c4e468042f6687",
    lat: 40.3740467,
    lng: 71.26526,
  },

  {
    _id: "62fddc3fd5d54d9b7b603453",
    lat: 40.3740459,
    lng: 71.2652632,
  },
  {
    _id: "62fddc05d5d54d9b7b603445",
    lat: 40.3740458,
    lng: 71.2652636,
  },
  {
    _id: "62fddbc3d5d54d9b7b603437",
    lat: 40.3740462,
    lng: 71.2652634,
  },
  {
    _id: "62fddb83d5d54d9b7b60342a",
    lat: 40.3740468,
    lng: 71.2652611,
  },
  {
    _id: "62fddb5cd5d54d9b7b603421",
    lat: 40.374043,
    lng: 71.2652757,
  },
  {
    _id: "62fddb2cd5d54d9b7b603413",
    lat: 40.3740377,
    lng: 71.2652814,
  },
  {
    _id: "62fddaead5d54d9b7b603402",
    lat: 40.3740463,
    lng: 71.2652628,
  },
  {
    _id: "62fdd7f2d5d54d9b7b60334d",
    lat: 40.3740462,
    lng: 71.2652619,
  },
  {
    _id: "62fcfebdb382ebff450e73b5",
    lat: 40.3740463,
    lng: 71.2653262,
  },
  {
    _id: "62fcf4e796f33228b136a9e5",
    lat: 40.3740502,
    lng: 71.2652269,
  },
  {
    _id: "62fcf342ea4a02214b8804af",
    lat: 40.3740455,
    lng: 71.2653221,
  },
  {
    _id: "62fcee73ea4a02214b880311",
    lat: 40.374047,
    lng: 71.2653155,
  },
  {
    _id: "62fce9bbfe8bf173b45c9908",
    lat: 40.3740475,
    lng: 71.2653273,
  },
  {
    _id: "62fcdc38bf50819cc38a137e",
    lat: 40.3740484,
    lng: 71.2652913,
  },
  {
    _id: "62fcbc1015dce3dc69ffbc24",
    lat: 40.3740462,
    lng: 71.2653101,
  },
  {
    _id: "62fcba4f04f22bc9cf06f019",
    lat: 40.3740472,
    lng: 71.2653092,
  },
  {
    _id: "62fcb7c704f22bc9cf06ef8b",
    lat: 40.3740478,
    lng: 71.2653272,
  },
  {
    _id: "62fbb5e3b6fba2c266c5cac2",
    lat: 40.3740491,
    lng: 71.2652553,
  },
  {
    _id: "62fbb566b631f0893faa731e",
    lat: 40.3740495,
    lng: 71.2652429,
  },
  {
    _id: "62fbb453422b36c5496ff6ab",
    lat: 40.3740481,
    lng: 71.2652442,
  },
  {
    _id: "62fb793f0eb21fd2260c44b5",
    lat: 40.3740502,
    lng: 71.2652427,
  },
  {
    _id: "62fb67c0bc314fdd99fc75d3",
    lat: 40.3740501,
    lng: 71.2652428,
  },
  {
    _id: "62fb6615dceef17755838088",
    lat: 40.3740502,
    lng: 71.2652427,
  },
  {
    _id: "62f331b5728ed570de3b782b",
    lat: 40.3740502,
    lng: 71.2652428,
  },
  {
    _id: "62f0d3417593ae8c597bb04f",
    lat: 40.3740725,
    lng: 71.2653471,
  },

  {
    _id: "62ebbb5e3c128d3335e4f2cc",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebbaef3c128d3335e4f27e",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebba953c128d3335e4f26f",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebba933c128d3335e4f26b",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebba913c128d3335e4f267",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebba8e3c128d3335e4f263",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebba183c128d3335e4f250",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebb9e43c128d3335e4f24c",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebb9dc3c128d3335e4f248",
    lat: 40.3740693,
    lng: 71.265341,
  },
  {
    _id: "62ebc9b0b4e3034f4fb60b0f",
    lat: 40.4262369,
    lng: 71.5191654,
  },
  {
    _id: "62e8d3a37298e5e8f02f9363",
    lat: 40.374072,
    lng: 71.2653472,
  },
  {
    _id: "62e8c5407298e5e8f02f92fb",
    lat: 40.3740723,
    lng: 71.2653472,
  },
  {
    _id: "62e7d78c9ea2ff5d7fa7d281",
    lat: 40.374069,
    lng: 71.2653008,
  },
  {
    _id: "62e7747906cc3f8f843ca3e2",
    lat: 40.3740655,
    lng: 71.2652995,
  },
  {
    _id: "62e7a9d7df90e44da8127236",
    lat: 40.3740662,
    lng: 71.2653017,
  },
  {
    _id: "62e7a9d4df90e44da8127227",
    lat: 40.3740657,
    lng: 71.2653012,
  },
  {
    _id: "62e7a9d5df90e44da8127230",
    lat: 40.3740695,
    lng: 71.2653008,
  },
  {
    _id: "62e7a96edf90e44da8127050",
    lat: 40.3740657,
    lng: 71.2653012,
  },
  {
    _id: "62e7a5b65ceb8a00d132c358",
    lat: 40.3724815,
    lng: 71.266076,
  },
  {
    _id: "62e7a4e75ceb8a00d132c307",
    lat: 40.3740663,
    lng: 71.2653006,
  },
]

export const sliderData = Array.from({
  length: Number(moment().year()) - 1899,
}).map((_, idx) => 1900 + idx)
export const mapColors = [
  "bg-[#FF0000]",
  "bg-[#FF3333]",
  "bg-[#FF6666]",
  "bg-[#FF9999]",
  "bg-[#93EB93]",
  "bg-[#62E062]",
  "bg-[#31D631]",
  "bg-[#00CC00]",
  "bg-[#3399FF]",
  "bg-[#5CADFF]",
  "bg-[#85C2FF]",
  "bg-[#ADD6FF]",
]
export const mapYears = [
  1900, 1910, 1920, 1930, 1940, 1950, 1960, 1970, 1980, 1990, 2000, 2023,
]
export const PageButtons = [
  {
    id: 1,
    title: "Рўйҳат",
    href: "/works",
  },
  {
    id: 2,
    title: "Ҳарита",
    href: "/",
  },
]
